import { inject } from "fw";
import { Store, handle } from "fw-state";

import { LogoutAction, StartAction } from "./actions";
import { CommonAppIntegrationRepository } from "network/common-app-integration-repository";
import { CreateCommonAppIntegrationAction, UpdateCommonAppIntegrationAction } from "forms/common-app-integration";
import { FormErrorHandling } from "./error-handling";

interface ICommonAppIntegrationsShape {
    loaded: boolean;
}

@inject
export class CommonAppIntegrationsStore extends Store<ICommonAppIntegrationsShape> {
    constructor(private integrationRepo: CommonAppIntegrationRepository) {
        super();
    }

    defaultState() {
        return {
            loaded: false,
            environments: []
        };
    }

    @handle(StartAction)
    @handle(LogoutAction)
    private handleDefaultActions() {
        this.setState(() => this.defaultState());
    }

    @handle(CreateCommonAppIntegrationAction, FormErrorHandling)
    private async handleCreateCommonAppIntegration(action: CreateCommonAppIntegrationAction) {
        action.form.validate();

        const { CommonAppYear, SdsUsername, SdsPassword, Enabled, DataCatalog } = action.form;

        action.created = await this.integrationRepo.post(action.organizationId, {
            CommonAppYear,
            SdsUsername,
            SdsPassword,
            Enabled,
            DataCatalog
        });
    }

    @handle(UpdateCommonAppIntegrationAction, FormErrorHandling)
    private async handleUpdateCommonAppIntegration(action: UpdateCommonAppIntegrationAction) {
        action.form.validate();

        const { CommonAppYear, SdsUsername, SdsPassword, Enabled, DataCatalog } = action.form;

        action.updated = await this.integrationRepo.put(action.commonAppIntegrationId, {
            CommonAppYear,
            SdsUsername,
            SdsPassword,
            Enabled,
            DataCatalog
        });
    }

    // @handle(CommonAppIntegrationsBustCacheAction)
    // private async handleBustCacheAction() {
    //   this.setState(() => this.defaultState());
    //   resetAllOnce();
    //   await this.handleEnsureAction();
    // }

    // @handle(CommonAppIntegrationsEnsureAction)
    // private async handleEnsureAction() {
    //   await once("ensure-common-app-integrations", async () => {
    //     if (this.state.loaded) return;
    //     this.update();
    //   });
    // }

    private async update() {
        if (this.state.loaded) return;

        this.setState((state) => ({
            ...state,
            loaded: true
        }));
    }
}
